var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12" }, [
            _c("div", { staticClass: "table-responsive" }, [
              _c("table", [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.comprobantes, function(comprobante, index) {
                    return _c("tr", { key: index }, [
                      _c("td", [_vm._v(_vm._s(comprobante.numero))]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm
                              .moment(comprobante.fecha_emision)
                              .format("DD/MM/YYYY")
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "button",
                          {
                            staticClass: "btn-info",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.$emit("seleccionar", comprobante)
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-check" })]
                        )
                      ])
                    ])
                  }),
                  0
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row end-xs" }, [
          _c(
            "button",
            {
              staticClass: "btn-danger btn--text",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.$emit("cerrar")
                }
              }
            },
            [
              _c("i", { staticClass: "fa fa-ban" }),
              _vm._v(" "),
              _c("span", [_vm._v("Cerrar")])
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("span", [_vm._v("Comprobantes coincidentes")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Número de comprobante")]),
        _vm._v(" "),
        _c("th", [_vm._v("Fecha de emisión")]),
        _vm._v(" "),
        _c("th", [_vm._v("Acción")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00dfc8a6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00dfc8a6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/CoincidenciaComprobantes.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-00dfc8a6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/CoincidenciaComprobantes.vue
// module chunks = 0